import React from 'react';

const TokenRefreshLoader = ({ isVisible }) => {
  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg p-6 shadow-xl flex items-center space-x-3 max-w-sm mx-4">
        <div className="animate-spin rounded-full h-6 w-6 border-b-2 border-blue-600"></div>
        <div className="flex flex-col">
          <span className="text-gray-700 font-medium">Refreshing session...</span>
          <span className="text-gray-500 text-sm">Please wait a moment</span>
        </div>
      </div>
    </div>
  );
};

export default TokenRefreshLoader;